import $ from 'jquery';

export default class {

    constructor() {
        this.init();
    }

    init() {
        var $diet_types = $('[data-diet_type]');
        function toTitleCase(str) {
            return str.replace(/(?:^|\s)\w/g, function(match) {
                return match.toUpperCase();
            });
        }
        if ( $diet_types.attr('data-diet_type') ) {
            $diet_types.each(function(i) {
                if (i == 0) {
                    $(this).addClass('active-recipe');
                }
                var data_diet_type = $(this).attr('data-diet_type');
                $('#diet_type').append('<option value="' + data_diet_type + '">' + toTitleCase(data_diet_type) + '</option>');
                console.log('active recipe statement');
            });
            $('body').on('change', '#diet_type', function(){
                var $selected_value = $(this).val();
                var $selected_recipe = $('[data-diet_type="'+ $selected_value +'"]');
                if (!$selected_recipe.hasClass('active-recipe')) {
                    $diet_types.removeClass('active-recipe');
                    $selected_recipe.addClass('active-recipe');
                }
                console.log('diet change statement');
            });
        }
        else {
            $('#diet_type_select').remove();
            $('.how-to-make').addClass('active-recipe');
            $('.diet-type-header').addClass('hidden');
            console.log('else statement');
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/DietTypeSelector.js